import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function DevOpsSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["devops-engineer"]} />;
}
